import { createBrowserRouter, RouteObject } from 'react-router-dom';
import React, { Suspense } from 'react';
import Spinner from '@cloudscape-design/components/spinner';

import AppContainer from 'src/components/common/AppContainer/AppContainer';

import { ROUTES } from './routes';
import Landing from 'src/components/pages/LandingPage';

// Lazy-load heavy pages — keeps them out of the main bundle
const ControlHomePage = React.lazy(() =>
  import('src/components/pages/ControlHomePage').then((m) => ({ default: m.ControlHomePage }))
);
const SummaryPage = React.lazy(() =>
  import('src/components/pages/SummaryPage').then((m) => ({ default: m.SummaryPage }))
);
const HistoricalExecutionsPage = React.lazy(() =>
  import('src/components/pages/HistoricalExecutionsPage').then((m) => ({
    default: m.HistoricalExecutionsPage,
  }))
);
const ReportsPage = React.lazy(() =>
  import('src/components/pages/ReportsPage').then((m) => ({ default: m.ReportsPage }))
);
const ProcurementDefectsPage = React.lazy(() =>
  import('src/components/pages/ProcurementDefectsPage').then((m) => ({
    default: m.ProcurementDefectsPage,
  }))
);

const LazyRoute = ({ children }: { children: React.ReactNode }) => (
  <Suspense
    fallback={
      <div style={{ display: 'flex', justifyContent: 'center', padding: '100px' }}>
        <Spinner size="large" />
      </div>
    }
  >
    {children}
  </Suspense>
);

export const routeConfig = [
  {
    path: ROUTES.HOME,
    element: <AppContainer />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: ROUTES.CONTROL.BASE,
        element: (
          <LazyRoute>
            <ControlHomePage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.CONTROL.SUMMARY,
        element: (
          <LazyRoute>
            <SummaryPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.CONTROL.HISTORICAL,
        element: (
          <LazyRoute>
            <HistoricalExecutionsPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.REPORTS.DETAIL,
        element: (
          <LazyRoute>
            <ReportsPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.PROCUREMENT.BASE,
        element: (
          <LazyRoute>
            <ProcurementDefectsPage />
          </LazyRoute>
        ),
      },
    ],
  },
];

export const router = createBrowserRouter(routeConfig as RouteObject[]);
